import { useCallback, useState } from "react"

import { getSubmit } from "ui-seeker/utils"


export default function useAppAsyncSelect() {

    const [state, setState] = useState({
        isLoading: false, options: []
    })

    const updateState = useCallback(newState => {
        setState(state => ({ ...state, ...newState }))
    }, [setState])

    const setLoading = useCallback(newLoading => {
        updateState({ isLoading: newLoading })
    }, [updateState])

    const setOptions = useCallback(newOptions => {
        updateState({ options: newOptions, isLoading: false })
    }, [updateState])

    const promiseOptions = (urlAjax, inputValue, extraParams={}, value=[], additionalHeaders={}) => {
        const selected = Array.isArray(value)
            ? value.join(',')
            : value || ''

        setLoading(true)

        return getSubmit(urlAjax, {
            qs: inputValue,
            selected: selected,
            ...extraParams
        }, additionalHeaders).then(data => {
            setOptions(data)
            return data
        })
    }

    return {
        isLoading: state.isLoading, options: state.options,
        updateState, setLoading, setOptions, promiseOptions
    }
}